var i=Object.freeze({error:"id_error_icon",info:"id_info_icon",success:"id_success_icon",warning:"id_warning_icon"});export{i as ICON_ID_TYPES};
//# sourceMappingURL=Dialog.constants.js.map
